/**
 * ─────────────────────────────────────────────────────────────────────────
 * NAGISOT — single source of truth for all public URLs.
 *
 * Values live in /nagisot.config.json at the repo root (so both TypeScript
 * consumers and Node-loaded build scripts can read them without module-
 * resolution headaches).
 *
 * To switch to a custom domain (e.g. nagisot.co.il):
 *   1. Edit /nagisot.config.json
 *   2. `pnpm -r build`
 *   3. Redeploy dashboard + widget + worker
 * ─────────────────────────────────────────────────────────────────────────
 */

import config from '../../../nagisot.config.json';

/** Marketing site / dashboard / articles. */
export const SITE_ORIGIN: string = config.siteOrigin;

/** Cloudflare Worker — REST API. */
export const API_ORIGIN: string = config.apiOrigin;

/** Where the customer-facing widget bundle is served from. */
export const WIDGET_CDN_ORIGIN: string = config.widgetCdnOrigin;

/** Cache-bust query param for the widget loader (bump on breaking changes). */
export const WIDGET_VERSION: string = config.widgetVersion;

/** Brand label. */
export const BRAND: string = config.brand;

/** Customer support / privacy contact. */
export const SUPPORT_EMAIL: string = config.supportEmail;

/** The Site ID we use to embed NAGISOT on the dashboard itself (dogfood). */
export const DASHBOARD_SITE_ID: string = config.dashboardSiteId;

/** Convenience composer for the widget script snippet shown to customers. */
export function widgetSnippet(siteId: string): string {
  return `<script src="${WIDGET_CDN_ORIGIN}/loader.js?${WIDGET_VERSION}" data-site="${siteId}" defer></script>`;
}
